var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ticket-line-details',{attrs:{"ticket-open-bets":_vm.ticketOpenBets,"ticket-graded-bets":_vm.ticketGradedBets,"scan-detail-response":_vm.scanDetailResponse}})}
var staticRenderFns = []

export { render, staticRenderFns }